// Identifica erro de rede, não a causa: pode ser firewall, DNS, proxy ou o
// serviço fora do ar. A ausência de `response` é o sinal-chave, porque bloqueio
// nunca produz resposta HTTP e erro de aplicação sempre produz.
const isNetworkError = (error) =>
  !!error &&
  !error.response &&
  ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code)

export default {
  isNetworkError,
}
